import React from "react";
import {
    HStack,
    Box,
    Button,
    Text,
    Tag,
    TagLabel
} from "@chakra-ui/react";
import { InviteStaffForm } from "../../components/InviteStaffForm";
import { PaginatedDataTable } from "../../components/PaginatedDataTable";
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { ModalBox } from "../../components/ModalBox";
import { useStaff } from "./useStaff";
import { HelmetComponent } from "../../components/HelmetComponent";
import NoDataMessage from "../../components/NoDataMessage";

export const StaffPage = () => {
    const {
        staffs, 
        formData, 
        errors,
        loading,
        isInvitingUser,
        isOpen,
        onOpen,
        isDeleteModalOpen,
        onDeletePopupClose,
        handleChange,
        updateCallback,
        deleteCallback,
        onInviteModalClose,
        deActivateMember,
        handleConfirm,
        user,
        publisher
    } = useStaff();

    const gameColumns = [
        { Header: "First Name", accessor: "firstName" },
        { Header: "Last Name", accessor: "lastName" },
        { Header: "Email", accessor: "email" },
        { Header: "Role", accessor: "role" },
        { 
            Header: "Status", 
            accessor: "isActive",
            Cell: ({
                cell: {
                  value,
                },
            }) => (
                <Tag
                    variant='solid'
                    sx={{
                        background: value ? "#4CAF50" : "#9E9E9E",
                        color: "#fff"
                    }}
                >
                    <TagLabel>{value ? "Active" : "De-activated"}</TagLabel>
                </Tag>
            ),
        },
        {
          Header: "  ",
          Cell: ({ cell }) => {
            return (
              <Button
                variant={"ghost"}
                colorScheme="blue"
                _hover={{ bg: "trasnparent", color: "blue.80"}}
                padding="0"
                disabled={!cell?.row?.original?.isActive}
                onClick={() => {if(cell?.row?.original?.isActive) updateCallback(cell?.row?.original)}}
              >
                Update
              </Button>
            );
          },
        },
        {
          Header: " ",
          Cell: ({ cell }) => {
            return cell?.row?.original?.isActive ? (
              <Button
                variant={"ghost"}
                color="red.500"
                _hover={{ bg: "trasnparent", color: "red.80"}}
                padding="0"
                onClick={() => deleteCallback(cell.row.original)}
              >
                De-Activate
              </Button>
            ) : (
                <Button
                  variant={"ghost"}
                  color="red.500"
                  _hover={{ bg: "trasnparent", color: "red.80"}}
                  padding="0"
                  onClick={() => deleteCallback(cell.row.original)}
                >
                  Activate
                </Button>
            );
          },
        },
      ];

    return (
        <>
            <HelmetComponent title={`Staff - Home - ${user.firstName} ${user.lastName}`}/>
            { 
              loading ? <LoadingOverlay /> :
              staffs?.length === 0 ? 
                <NoDataMessage 
                  title="No Staff Members Found" 
                  desc="You haven’t added any staff members yet. Invite your team to collaborate and manage tasks." 
                  buttonText="Invite Staff" 
                  onClick={onOpen} 
                  filterType="staffs"
                  disabled={!publisher.isPro}
                /> :
                <>
                  {
                    staffs?.length > 0 ?
                    <HStack justifyContent="space-between" mb={1} marginTop="20px">
                        <Box></Box>
                        <Button colorScheme="blue" onClick={onOpen} disabled={!publisher.isPro}>Invite</Button>
                    </HStack> : <></>
                  }
                  <PaginatedDataTable
                      columns={gameColumns}
                      data={staffs}
                      showNumberOfRecords={50}
                  />
                </>
            }
            <ModalBox
                title={formData?.id ? "Update member" : "Invite member"}
                description={
                    <InviteStaffForm
                        formData={formData}
                        errors={errors}
                        isInvitingUser={isInvitingUser}
                        isUpdate={!!formData?.id}
                        handleChange={handleChange}
                    />
                }
                isOpen={isOpen}
                onClose={onInviteModalClose}
                onCancel={onInviteModalClose}
                isFooter={true}
                cancelButtonText="Cancel"
                loadingText={formData?.id ? "Updating" : "Inviting"}
                isWorking={isInvitingUser}
                confirmButtonText={formData?.id ? "Update" : "Invite"}
                onConfirm={handleConfirm}
            />
            <ModalBox
                title={`${formData?.isActive ? 'De-activate' : 'Activate'} user`}
                description={
                <Text fontSize="lg">
                    Are you sure you want to {formData?.isActive ? 'de-activate' : 'activate'} {formData?.firstName} {formData?.lastName}.
                </Text>
                }
                isOpen={isDeleteModalOpen}
                onClose={onDeletePopupClose}
                isFooter={true}
                loadingText={formData?.isActive ? 'De-activating' : 'Activating'}
                isWorking={isInvitingUser}
                onCancel={onDeletePopupClose}
                onConfirm={deActivateMember}
                cancelButtonText="Cancel"
                confirmButtonText={formData?.isActive ? 'De-activate' : 'Activate'}
                isDeleteButton={formData?.isActive}
            ></ModalBox>
        </>
    );
};
